export default __webpack_public_path__ + "static/media/CPC.4bab938a.png";